export class Customer {
  public id: string;
  public createdAt: Date;
  public updatedAt: Date;
  public countryCode: string;
  public email: string;
  public emailVerified: boolean;
  public fromCampaign: {[key: string]: string};
  public loyalty: boolean;
  public profile: Profile;
  public preferences: Preferences;

  constructor (data:any) {
    this.id            = data.id;
    this.createdAt     = data.createdAt ? new Date (data.createdAt) : undefined;
    this.updatedAt     = data.updatedAt ? new Date (data.updatedAt) : undefined;
    this.countryCode   = data.countryCode;
    this.email         = data.email;
    this.emailVerified = data.emailVerified;
    this.fromCampaign  = data.fromCampaign;
    this.loyalty       = data.loyalty;

    if (data.profile) {
      this.profile = new Profile(data.profile);
    }

    if (data.preferences) {
      this.preferences = new Preferences(data.preferences);
    }
  }
}

export class Session {
  public token: string;
  public customerId: string;
  public validUntil: Date;

  constructor (data:any) {
    this.token         = data.token;
    this.customerId    = data.customerId;
    this.validUntil    = data.validUntil ? new Date (data.validUntil) : undefined;
  }
}

export class CustomerWithSession {
  public customer: Customer;
  public session: Session;

  constructor (data:any) {
    if (data.customer) {
      this.customer = new Customer(data.customer);
    }

    if (data.session) {
      this.session = new Session(data.session);
    }
  }
}


export class Profile {
  public firstName         : string;
  public lastName          : string;
  public birthday          : Date;
  public gender            : Gender;
  public size              : string;
  public avatarUrl         : string;
  public storeId           : string;
  public phoneNumber       : string;
  public address           : Address;

  constructor (data:any) {
    this.firstName     = data.firstName;
    this.lastName      = data.lastName;
    this.birthday      = data.birthday ? new Date (data.birthday) : undefined;
    this.gender        = data.gender;
    this.size          = data.size;
    this.avatarUrl     = data.avatarUrl;
    this.storeId       = data.storeId;
    this.phoneNumber   = data.phoneNumber;


    if (data.address) {
      this.address = new Address(data.address);
    }
  }
}

export class Address {
  public street     : string;
  public postalCode : string;
  public city       : string;
  public country    : string;


  constructor (data:any) {
    this.street     = data.street;
    this.postalCode = data.postalCode;
    this.city       = data.city;
    this.country    = data.country;
  }
}

export class Preferences {
  public optInConfirmed: boolean;
  public optInEmailAdvertisementConsent: boolean;
  public optInEmailChannelNewsletter: boolean;
  public optInEmailChannelLoyalty: boolean;
  public optInEmailChannelWomensFashion: boolean;
  public optInEmailChannelMensFashion: boolean;


  constructor(data: any) {
    this.optInConfirmed = data.optInConfirmed;
    this.optInEmailAdvertisementConsent = data.optInEmailAdvertisementConsent;
    this.optInEmailChannelNewsletter = data.optInEmailChannelNewsletter;
    this.optInEmailChannelLoyalty = data.optInEmailChannelLoyalty;
    this.optInEmailChannelWomensFashion = data.optInEmailChannelWomensFashion;
    this.optInEmailChannelMensFashion = data.optInEmailChannelMensFashion;
  }
}

export enum Gender {
  Male = "MALE",
  Female = "FEMALE",
  NA = "N_A",
}

export class CustomerEmailChannels {
  public email: string;
  public newsletterOnly: boolean;
  public loyalty: boolean;
  public channels: {
    optInEmailChannelNewsletter:    boolean;
    optInEmailChannelLoyalty:       boolean;
    optInEmailChannelWomensFashion: boolean;
    optInEmailChannelMensFashion:   boolean;
  };

  constructor(data: any) {
    this.email = data.email;
    this.newsletterOnly = data.newsletterOnly;
    this.loyalty = data.loyalty;
    this.channels = data.channels;
  }
}

export class OptInState {
  public action: string;
  public emailVerified: boolean;
  public optInConfirmed: boolean;
  public advertisementConsent: boolean;

  constructor(data: any) {
    this.action = data.action;
    this.emailVerified = data.emailVerified;
    this.optInConfirmed = data.optInConfirmed;
    this.advertisementConsent = data.advertisementConsent;
  }
}
